import React, { useState, useRef, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, Icon, IconButton, Checkbox,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, ModalFooter,
} from '@chakra-ui/react';
import { MdSave } from 'react-icons/md';
import { Form, Field } from 'react-final-form';

function AddEditServicePriceModal({ 
    company_id, servicePriceDetail, actionStatus, initialRef, isOpen, onClose, 
    apiCreateNewServicePrice, apiUpdateAServicePrice,
}) {
    const [ cookies ] = useCookies(["loginCookie"]);
    const [ isProcessing, setIsProcessing ] = useState(false);

    useEffect(() => {
        if(!actionStatus) {
            setIsProcessing(false);
        }
    }, [actionStatus]);

    const validate = (values) => {
        const errors = {};

        if(!values.name) {
            errors.name = "Required";
        }
        if(!values.price) {
            errors.price = "Required";
        }

        return errors;
    }

    const onSubmit = async(values) => {
        setIsProcessing(true);
        if(servicePriceDetail && servicePriceDetail.id) {
            apiUpdateAServicePrice({ 
                id: servicePriceDetail.id, 
                payload: {
                    ...values, 
                    user_id: cookies?.loginCookie?.data?.id,  
                }
            });
        } else {
            apiCreateNewServicePrice({ 
                ...values,
                user_id: cookies?.loginCookie?.data?.id,   
            });
        }
    }

    return (
        <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} size="md">
            <ModalOverlay />
            <Form
                onSubmit={onSubmit}
                initialValues={{
                    company_id,
                    ...servicePriceDetail
                }}
                validate={validate}
                render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <ModalContent>
                                <ModalHeader>
                                    { servicePriceDetail && servicePriceDetail.id ? "CẬP NHẬT" : "TẠO MỚI" }
                                </ModalHeader>
                                <ModalCloseButton />

                                <ModalBody pb={6}>
                                    <Field name="name">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Tên dịch vụ</FormLabel>
                                                <Input {...input} type='text' placeholder='Nhập tên dịch vụ' />
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="price">
                                        {({ input, meta }) => (
                                            <FormControl isRequired>
                                                <FormLabel>Đơn giá (VND)</FormLabel>
                                                <Input {...input} type='number' placeholder='Nhập Đơn giá' />
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Field name="is_initial_fee" type='checkbox'>
                                        {({ input, meta }) => (
                                            <Checkbox {...input} isChecked= { input.checked } colorScheme='orange'>
                                                Phí tính mặc định khi bệnh nhân đặt lịch khám
                                            </Checkbox>
                                        )}
                                    </Field>
                                </ModalBody>

                                <ModalFooter>
                                    <Button colorScheme='blue' mr={3} type='submit' isDisabled={!valid | pristine}
                                        isLoading={isProcessing}
                                        loadingText="Đang lưu"
                                    >
                                        <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                        <Text fontSize="14px">Lưu</Text>
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </form>
                    )
                }}
            />
        </Modal>
    )
}

export default AddEditServicePriceModal;